export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9105.ef3eeea7.jpg";